import React from "react";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Button from "react-bootstrap/Button";
import { PersonCircle, FileEarmarkSpreadsheetFill, PeopleFill,Pencil,ArrowUpCircle, ArrowDownCircle } from 'react-bootstrap-icons';

const Help = (props) => {
    const adminHome = ( 
    <div>
        <h3>Admin Home</h3>
        <ul>
            <li>Menu</li>
        </ul>
    </div>);

    const adminUsers = ( 
    <div>
        <h3>Users</h3>
        <h4>Add User</h4>
        <p>
            Press the <Button><PersonCircle/ > Add User</Button> button to create a new user.  You must fill in the name, email address and starting balance fields.  
            You can fill in the address if available.  The user will recieve an email inviting them to join.  They can fill in the 
            rest of their details at that time and set their password. 
        </p>
        <h4>Bulk Upload</h4>
        <p>
            If you have a lot of users to add at once, you can upload a spreadheet with the users' information by pressing <Button><PeopleFill/ > Bulk Upload Users</Button>. 
            Each user will be created and sent an email with instructions on completing their registration.
            rest of their details at that time and set their password. 
        </p>
        <h4>Generate Report</h4>
        <p>
            By pressing the <Button color="success"><FileEarmarkSpreadsheetFill/>Generate Report</Button>, a spredsheet 
            with all users will be generated.
        </p>
    </div>);

    const adminCategories = ( 
        <div>
            <h3>Categories</h3>
            <p>
                The Categories are what appear in the menu on the site.  
                On this page, you can customize the name of each category and change it's order in the menu.
            </p>
            <p>
                To edit the name, click the <Pencil /> next to the category. A dialog will appear and you can edit the name.
            </p>
            <p>
                To change the order in the menu, click the <ArrowUpCircle size={25}/> or <ArrowDownCircle size={25}/> next to the category. The category will change position in the list.
            </p>

        </div>
    );

    const adminOrders = ( 
        <div>
            <h3>Orders</h3>
            <p>
                This page shows all the orders from your users.  You can page through orders or filter then on their status. 
            </p>
            <p>
                When an order is submitted by a user, it must be approved before it is sent to be created.  To approve an order, click
                  <Button variant="success" >Approve Order</Button>
            </p>
            <p>
                To cancel an order, click
                <Button variant="danger">Cancel Order</Button>.  Funds may be returned to the user, depending on how you have replenishment setup. 
            </p>
        </div>
    );

    const adminCatalog = ( 
        <div>
            <h3>Catalog</h3>
            <p>
                This page shows your current product offerings.  The menu at the top shows the categories.  Click on a category to see what products are offered under that category. Click on a product to change the logo, update colors and see available sizes.
            </p>
        </div>
    );

    const adminProductDetails = ( 
        <div>
            <h3>Product Details</h3>
            <p> 
                This page shows product details that appear on your site.
            </p>
            <p> 
                <strong>PLEASE NOTE: All changes to this page will be published to your live site immediately.</strong>
            </p>
            <h4>Logo</h4>
            <p>
                You can select which logo you want this product to be decorated with.  Choose the logo in the Available Logos dropdown.
            </p>
            <p>
                Your currently selected logo is shown below your chosen logo.
            </p>
            <h4>Colors</h4>
            <p>
                The Selected Colors section shows which colors you have chosen to be avaiable for purchase.  To remove a color, drag it out of the Selected Colors section.  A dialog will appear allowing you to confirm the removal.
            </p>
            <p>
                To add a color, drag the color from the Available COlors box to the Selected Colors box.  All sizes for that color will be added.
            </p>
            <h4>Sizes</h4>
            <p>
                Sizes and pricing are shown for the selected color. Click on any color to see the available sizes and prices.
            </p>
        </div>
    );
    const adminAllProducts = ( 
        <div>
            <h3>Available Products</h3>
            <p>
                This page shows all avaiable products that you can add to your site. You can search for a specific model or 
                use general terms like "polo". After searching, you can select a product and view it's details.
            </p>
        </div>
    );

    const adminAllDetails = ( 
        <div>
            <h3>Product Details</h3>
            <p> 
                This page shows product details for the product you want to add to your site. You can select the colors that you want available. 
                After adding the product to your catalog, you can select the logo and change colors from the Catalog section of the Admin.
            </p>
            <h4>Colors</h4>
            <p>
                The Selected Colors section shows which colors you have chosen to be avaiable for purchase.  To remove a color, drag it out of the Selected Colors section.  A dialog will appear allowing you to confirm the removal.
            </p>
            <p>
                To add a color, drag the color from the Available COlors box to the Selected Colors box.  All sizes for that color will be added.
            </p>
        </div>
    );

    const adminLogos = ( 
        <div>
            <h3>Logos</h3>
            <p>
                This page shows what logos are available for your products.  To add a logo, please contact your Ignite sales representive.
            </p>
        </div>
    );

    let text="";
  console.log("HELP props", props);
    if(props.route === "/admin/home") {
        text = adminHome;
    } else if(props.route === "/admin/users") {
        text = adminUsers;
    } else if(props.route === "/admin/categories") {
        text = adminCategories;
    } else if(props.route === "/admin/orders") {
        text = adminOrders;
    } else if(props.route.includes("/admin/catalog")) {
        text = adminCatalog;
    } else if(props.route.includes("/admin/product/details")) {
        text = adminProductDetails;
    } else if(props.route.includes("/admin/allcatalog")) {
        text = adminAllProducts;
    } else if(props.route.includes("/admin/allproduct/details")) {
        text = adminAllDetails;
    } else if(props.route.includes("/admin/logos")) {
        text = adminLogos;
    }
    
    
  return (
    <Container>
        {text}
    </Container>

  );
};
export default Help;



